import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useUnit } from 'effector-react';
import { replacePlanCode } from '@lib/billing-plan-name';
import { useOpenPaywallPopupNew } from '@nx-frontend/shared/hooks';
import { $currentOrganization } from '@nx-frontend/shared/store/current-organization';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { $opCanManageWorkspacesBranding, $orgRoleState } from '@nx-frontend/shared/store/org-role';
import {
  OrgMemberRole,
  OrgMemberRoleAndPrivileges,
  PaywallPopupPayload,
  PaywallPopupReason,
  PopupType,
} from '@nx-frontend/shared/types';

export const useOpenBranding = () => {
  const [opCanManageWorkspacesBranding, role, currentOrganization, currentWorkspace] = useUnit([
    $opCanManageWorkspacesBranding,
    $orgRoleState,
    $currentOrganization,
    $currentWorkspace,
  ]);
  const router = useRouter();
  const t = useTranslations();
  const openPaywallPopup = useOpenPaywallPopupNew();
  return () => {
    if (isNeedToShowMessageForBrandingFeature(role, opCanManageWorkspacesBranding)) {
      const message = replacePlanCode(
        'Branding pages is available only to users of the #team# or #business# plans. ' +
          'Contact the organization owner for more details.'
      );
      console.log(`Open text popup with message: ${message}`);
    } else if (opCanManageWorkspacesBranding) {
      router.push(
        `/space/settings/org/${currentOrganization.globalId}/ws/${currentWorkspace.globalId}?branding=public-links`
      );
    } else {
      const popupPayload: PaywallPopupPayload = {
        payloadType: PopupType.PAYWALL,
        title: t('features.paywall.title_brand_identity'),
        reason: PaywallPopupReason.BRANDING,
      };

      openPaywallPopup({ payload: popupPayload });
    }
  };
};

const isNeedToShowMessageForBrandingFeature = (
  roleItem: OrgMemberRoleAndPrivileges,
  canManageWorkspacesBranding: boolean
): boolean => {
  const currentOrgRole = roleItem ? roleItem.role : null;
  if (!currentOrgRole) {
    return false;
  }
  const isManagement = currentOrgRole === OrgMemberRole.OWNER || currentOrgRole === OrgMemberRole.MANAGER;
  return (
    (canManageWorkspacesBranding && !isManagement) ||
    (!canManageWorkspacesBranding && currentOrgRole !== OrgMemberRole.OWNER)
  );
};
